module.exports = __webpack_public_path__ + "img/icone_i.7205f16d.svg";